/* 
  main function to apply  filtering 
*/

import IsFinalCalledUp from "./IsFinalCalledUp";
import calculateCompletePctg from "./calculateCompletePctg";

// const extractDataByFilter = (stockdata,params,filtercategory, townhouseonly) => {
const extractDataByFilter = (
  stockdata,
  params,
  filtercategory,
  producttypefilter
) => {
  let land_price;
  let record_qualifies;
  console.log( "inside extractDataByFilter : params " + params + " | filtercategory: " + filtercategory + " | producttypefilter : " + JSON.stringify(producttypefilter));
  const stockdataFiltered_for_null = stockdata.filter(
    (a) => a[params[0]] !== null && a[params[0]] !== undefined
  );
  const stockdataFiltered = stockdataFiltered_for_null.filter(
    (a) => a.ProductType__c !== "House and Land"
  );
  const result =
    params.length > 3
      ? stockdataFiltered.reduce(
          (acc, o) => (
            (acc[o[params[0]][params[1]][params[2]]] = {
              sfid: o[params[3]],
              count: acc[o[params[0]][params[1]][params[2]]]
                ? acc[o[params[0]][params[1]][params[2]]].count + 1
                : 1,
              totallandprice: acc[o[params[0]]]
                ? acc[o[params[0]]].totallandprice + land_price
                : land_price,
              totallandsize: acc[o[params[0]]]
                ? acc[o[params[0]]].totallandsize + o.LandSize_r__c
                : o.LandSize_r__c,              
            }),
            acc
          ),
          {}
        )
      : params.length > 2
      ? stockdataFiltered.reduce(
          (acc, o) => (
            (record_qualifies =true),

            (acc[o[params[0]][params[1]]] = 
                  record_qualifies
                ?
                  {
              sfid: o[params[2]],
                  count: acc[o[params[0]][params[1]]] ? acc[o[params[0]][params[1]]].count + 1 : 1,
                    totallandprice:
                      acc[o[params[0]][params[1]]] ? acc[o[params[0]][params[1]]].totallandprice + land_price : land_price,
                    totallandsize:
                      acc[o[params[0]][params[1]]] ? acc[o[params[0]][params[1]]].totallandsize + o.LandSize_r__c : o.LandSize_r__c,
                    landsettled:
                      o.StatusDevr__c == "Settled"
                        ? acc[o[params[0]][params[1]]] ? acc[o[params[0]][params[1]]].landsettled + 1
                        : 1 : acc[o[params[0]][params[1]]] ? acc[o[params[0]][params[1]]].landsettled : 0,
            }
            : acc[o[params[0]][params[1]]]),
            acc
          ),
          {}
        )
      : filtercategory === "lot"
      ? //  stockdataFiltered.reduce( (acc, o) => (acc[o[params[0]]] = {sfid: o.Id, count: acc[o[params[0]]] ? acc[o[params[0]]].count+1 : 1, status: o.StatusDevr__c, price: land_price, buildprice: o.LatestMasterContract__r != null ? o.LatestMasterContract__r.BuildContractPrice__c : "", propertyprice: o.LatestMasterContract__r != null ?  o.LatestMasterContract__r.PropertyContractPrice__c : "",  buildstatus: o.LatestMasterContract__r != null ? o.LatestMasterContract__r.BuildContractStatus__c : "", propertystatus: o.LatestMasterContract__r != null ? o.LatestMasterContract__r.PropertyContractStatus__c : "", landsize: o.LandSize__c , streetnumber : o.StreetNumber__c, streetname : o.StreetName__c, suburb : o.Suburb__c, state : o.State__c , postcode :o.Postcode__c , depth : o.LandDepth__c, frontage : o.LandFrontage__c, iscorner : o.IsCornerLot__c, isirregular: o.IsIrregularLot__c, volume : o.Volume__c, folio : o.FolioNo__c, municipality : o.Municipality__c, lp: o.LP__c, ps: o.PS__c, projectvendor : o.ProjectVendor__c, jobcode: o.JobCodeconsolidated__c , allocgrp: o.AllocationGroup__c, projname:o.Project__r ? o.Project__r.Name : '', stage:o.Stage__r ? o.Stage__r.Name : '', lateststage:o.Milestone__c, tranche:o.Trancher__c } , acc), {})
        stockdataFiltered.reduce(
          (acc, o) => ((acc[o[params[0]]] = { lotrecord: o }), acc),
          {}
        )
      : stockdataFiltered.reduce(
            (acc, o) => (
                  (record_qualifies = true),
                  (acc[o[params[0]]] = record_qualifies ? acc[o[params[0]]] ? {
                        sfid: acc[o[params[0]]].sfid,
                        count: acc[o[params[0]]].count + 1,
                        totallandprice: acc[o[params[0]]].totallandprice + land_price,
                        totallandsize : acc[o[params[0]]].totallandsize + o.LandSize_r__c,                      
                        landsettled: o.StatusDevr__c == "Settled" ? acc[o[params[0]]].landsettled + 1 : acc[o[params[0]]].landsettled,
                        }
                  : {
                        sfid: null,
                        count: 1,
                        totallandprice: land_price,
                        totallandsize: o.LandSize_r__c
                        }
              : acc[o[params[0]]]),
            acc
          ),
          {}
        );

  const tempArray = [];
  for (const [key, value] of Object.entries(result)) {
    if (filtercategory === "lot") {
      tempArray.push({
        id: key + Math.random() * Math.random(),
        lotrecord: value.lotrecord,
      });
    } else {
      if (value) {
        tempArray.push({
          id: key + Math.random() * Math.random(),
          name: key,
          count: value.count,
          propertycount: value.propertycount,
          houseandlandcount: value.houseandlandcount,
          sfid: value.sfid,
          totallandprice: value.totallandprice,
          totallandsize: value.totallandsize,
          landsettled: value.landsettled,
        });
      }
    }
  }
  return tempArray;
};

export default extractDataByFilter;
